export default {
  ES_V2_FLAG: "es_v2",
  ES_V2_SEARCH_FLAG: "es_v2_search",
  ES_V2_CATEGORIES_FLAG: "es_v2_cat",
  ES_V2_AUTOSUGGEST_FLAG: "es_v2_auto",
};